const state = {
  id: null,
  token: null,
  userType: null,
  broker: null,
  realState: null
}

const mutations = {
  setToken (state, token) {
    state.token = token
  },

  setUserType (state, userType) {
    state.userType = userType
  },

  setBroker (state, broker) {
    state.broker = broker
  },

  setRealState (state, realState) {
    state.realState = realState
  },

  setId (state, id) {
    state.id = id
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js